import { render, staticRenderFns } from "./ordersExport.vue?vue&type=template&id=2d61e639&scoped=true"
import script from "./ordersExport.vue?vue&type=script&lang=js"
export * from "./ordersExport.vue?vue&type=script&lang=js"
import style0 from "./ordersExport.vue?vue&type=style&index=0&id=2d61e639&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d61e639",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d61e639')) {
      api.createRecord('2d61e639', component.options)
    } else {
      api.reload('2d61e639', component.options)
    }
    module.hot.accept("./ordersExport.vue?vue&type=template&id=2d61e639&scoped=true", function () {
      api.rerender('2d61e639', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/ordersExport.vue"
export default component.exports